<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!--heading and backbutton-->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Barcode</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home" alt="Home icon"></a>
        </div>
      </div>
      <!--End heading and backbutton-->
      <!-- START FORM VALIDATION STATES -->
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Barcode</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="pgLoad ? ngOnInit() : null"/>
        </div>
        <div class="Reports_form_div">
          <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="addDeviceForm">
            <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
              <!-- Business Count -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Barcode Count</mat-label>
                <input matInput type="text" id="barcodecount" autocomplete="off" formControlName="barcodeCount" placeholder="Enter count"
                  [(ngModel)]="barcode.barcode_count" (input)="updateButton ? updateBarcodeSequence() : null" (keyup)="updateButton ? changeCount() : null"/>
                <mat-hint><i>2-4 digits</i></mat-hint>
                <mat-error *ngIf="submitted && barcodeFormValidation.barcodeCount.errors">
                  <i *ngIf="barcodeFormValidation.barcodeCount.hasError('required')">Required.</i>
                  <i *ngIf="barcodeFormValidation.barcodeCount.hasError('minlength')">Minimum 2 numbers required.</i>
                  <i *ngIf="barcodeFormValidation.barcodeCount.hasError('maxlength')">Maximum 4 numbers allowed.</i>
                  <i *ngIf="barcodeFormValidation.barcodeCount.hasError('pattern')">Enter valid count.</i>
                </mat-error>
              </mat-form-field>

              <!-- Barcode From -->
              <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: updateButton }">
                <mat-label>Barcode From</mat-label>
                <input matInput type="text" id="barcodefrom" autocomplete="off" formControlName="barcodeFrom" placeholder="TEST0212202300000"
                  [(ngModel)]="barcode.barcode_from" (keyup)="barcodeSequence()"/>
                <mat-hint><i>17‑character barcode</i></mat-hint>
                <mat-error *ngIf="submitted && barcodeFormValidation.barcodeFrom.errors">
                  <i *ngIf="barcodeFormValidation.barcodeFrom.hasError('required')">Required.</i>
                  <i *ngIf="barcodeFormValidation.barcodeFrom.hasError('minlength')">Minimum 17 characters.</i>
                  <i *ngIf="barcodeFormValidation.barcodeFrom.hasError('maxlength')">Maximum 17 characters.</i>
                  <i *ngIf="barcodeFormValidation.barcodeFrom.hasError('pattern')">Enter valid barcode.</i>
                </mat-error>
              </mat-form-field>
              <!-- Barcode To -->
              <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: updateButton }">
                <mat-label>Barcode To</mat-label>
                <input matInput type="text" id="barcodeto" autocomplete="off" formControlName="barcodeTo" placeholder="TEST0212202300000" [(ngModel)]="barcode.barcode_to" />
                <mat-hint><i>17‑character barcode</i></mat-hint>
                <mat-error *ngIf="submitted && barcodeFormValidation.barcodeTo.errors">
                  <i *ngIf="barcodeFormValidation.barcodeTo.hasError('required')">Required.</i>
                  <i *ngIf="barcodeFormValidation.barcodeTo.hasError('minlength')">Minimum 17 characters.</i>
                  <i *ngIf="barcodeFormValidation.barcodeTo.hasError('maxlength')">Maximum 17 characters.</i>
                  <i *ngIf="barcodeFormValidation.barcodeTo.hasError('pattern')">Enter valid barcode.</i>
                </mat-error>
              </mat-form-field>
              <!-- Barcode Sequence -->
              <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: updateButton || submitButton }">
                <mat-label>Barcode Sequence</mat-label>
                <input matInput type="text" id="barcodesequence" autocomplete="off" formControlName="barcodeSequence" placeholder="Enter sequence" [(ngModel)]="barcode.barcode_sequence"/>
                <mat-hint><i>12‑digit sequence</i></mat-hint>
                <mat-error *ngIf="submitted && barcodeFormValidation.barcodeSequence.errors">
                  <i *ngIf="barcodeFormValidation.barcodeSequence.hasError('required')">Required.</i>
                  <i *ngIf="barcodeFormValidation.barcodeSequence.hasError('minlength')">Minimum 12 numbers.</i>
                  <i *ngIf="barcodeFormValidation.barcodeSequence.hasError('maxlength')">Maximum 12 numbers.</i>
                  <i *ngIf="barcodeFormValidation.barcodeSequence.hasError('pattern')">Enter valid barcode.</i>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
          <div class="row">
            <div class="buttons-div">
              <div class="transactions-button-container" (click)="addBarcode()" *ngIf="submitButton">
                <button class="transaction-submit-button" [disabled]="addBarcodeDoubleClick">
                  <span class="icon"><img src="../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Submit</span>
                </button>
              </div>
              <div class="transactions-button-container" (click)="updateBarcode()" *ngIf="updateButton">
                <button class="transaction-submit-button" [disabled]="addBarcodeDoubleClick">
                  <span class="icon"><img src="../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">Update</span>
                </button>
              </div>
              <div class="transactions-button-container" (click)="cancel()">
                <button class="transaction-close-button">
                  <span class="icon"><img src="../../../../../assets/images/New_Icons/cross-icon.svg" alt="Cross icon"></span>
                  <span class="text">Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--add barcode form started-->
        <!--display customer barcode details after adding above input fields-->
        <div *ngIf="barcodes && barcodes.length>0" class="panel-body table-responsive">
          <table class="table">
            <thead class="thead-light">
            <tr>
              <th scope="col">S.No.</th>
              <th scope="col">Barcode Count</th>
              <th scope="col">Barcode From</th>
              <th scope="col">Barcode To</th>
              <th scope="col">Barcode Sequence</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let list of barcodes;let i=index">
              <td scope="row">{{i + 1}}</td>
              <td>{{list.barcode_count}}</td>
              <td>{{list.barcode_from}}</td>
              <td>{{list.barcode_to}}</td>
              <td>{{list.barcode_sequence}}</td>
              <td title="Edit Barcode">
                <img src="../../../../../assets/images/New_Icons/edit.svg" class="update-barcode" (click)="getBarcodeDetails(list.id)" alt="Edit icon">
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--display customer barcode details after adding above input fields-->
        <!--add barcode form started-->
      </div>
      <!-- END FORM VALIDATION STATES -->
    </div>
  </div>
  <!-- END PAGE CONTENT WRAPPER -->
</div>
<!-- END PAGE CONTENT WRAPPER -->

